import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { getTradingSystemName } from '@monorepo/client-types';
import { Stack, Typography } from '@monorepo/nova-ui';
import { PlatformLoginContentProps } from '../types';
import { PlatformButtonsSection } from './platform-buttons-section';

export const PlatformLoginContent: FunctionComponent<
  PlatformLoginContentProps
> = ({ tradingSystem }) => {
  const { t } = useTranslation(['login']);
  const platformName = getTradingSystemName(tradingSystem);

  return (
    <Stack gap={3}>
      <Typography variant="body1">
        {t('login:traders_login.platform_login_tip', {
          platform: platformName,
        })}
      </Typography>
      <PlatformButtonsSection
        tradingSystem={tradingSystem}
        isPrimaryColor={false}
      />
    </Stack>
  );
};
